module.exports = __webpack_public_path__ + "static/media/mailNew.0a4e314c.png";